<nh-form [individuals]="individuals" [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  @if(!rmcVolTermChangeSwitch){
  <nh-alert type="info" [isOpen]="infoMessage && !errorMessage && !ssiEligibleMessage">{{ "END_COVERAGE_VALIDATION" |
    globalTranslate }}
  </nh-alert>

  <nh-alert type="danger" [isOpen]="errorMessage">
    <div class="row" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="col-auto icon">
        <img src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
      </div>
      <div class="col message">
        <span class="visually-hidden">{{ "Warning" | globalTranslate }} </span>
        <span>{{ "END_COVERAGE_VALIDATION" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>

  <nh-alert type="danger" [isOpen]="ssiEligibleMessage">
    <div class="row" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="col-auto icon">
        <img src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
      </div>
      <div class="col message">
        <span class="visually-hidden">{{ "Warning" | globalTranslate }} </span>
        <span>{{ ssiName }}
          {{ "END_COVERAGE_VALIDATION_2" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>

  <div class="static-text">
    <p>{{ "END_COVERAGE_STATIC_TEXT1" | globalTranslate }}</p>
    <h1 class="section-header">{{ "End Coverage" | globalTranslate }}</h1>
    <hr />
    <p>{{ "END_COVERAGE_STATIC_TEXT2" | globalTranslate }}</p>
    <p>{{ "END_COVERAGE_STATIC_TEXT3" | globalTranslate }}</p>

    <div class="row ps-3">
      @for (indiv of members; track indiv; let i = $index) {
      <div [ngClass]="{ applyColor: selectedTile(indiv) }" class="card card-body shadow mr-3 mt-3 col-md-5"
        tabindex="0">
        <div (click)="selectedAction(indiv)">
          <div class="d-flex align-items-center">
            <ul>
              <li>
                <strong>{{ indiv.firstNam }} {{ indiv.lastNam }} </strong>
                <strong>{{ indiv.age }}</strong>
                <strong>{{ indiv.genderCd }}</strong>
              </li>
              <li>
                <div>
                  {{ "Case:" | globalTranslate }}
                  <strong>{{ indiv.caseNum }}</strong>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      } @if (hohId.length) {
      <div id="bckgrnd" class="card card-body shadow mr-3 mt-3 col-md-5" [ngClass]="{ applyColor: selectedTile(hohId) }"
        (click)="selectedAction(hohId)" tabindex="0">
        <div class="d-flex align-items-center ps-2">
          <div>{{ "END_COVERAGE_STATIC_TEXT4" | globalTranslate }}</div>
        </div>
      </div>
      }
      <br />
    </div>
    <br />
    <div>
      <nh-checkbox name="doNotEndCoverage" [control]="getControl('extras.helpers.doNotEndCoverage')"
        (change)="deselectMembers()" checkedValue="true" label="{{ 'END_COVERAGE_STATIC_TEXT5' | globalTranslate }}"
        [ariaLabel]="'END_COVERAGE_STATIC_TEXT5' | globalTranslate" index="endCoverage" class="label-section">
      </nh-checkbox>
    </div>
  </div>
  }@else if(rmcVolTermChangeSwitch) {
  @if(!members.length && !hohId?.length) {
  @if(isOnlyEndCoverageTileSelected){
  <div class="static-text card_align">
    <p [innerHTML]="'ENDCOVERAGE_NOTELIGIBLE_TEXT_01' | globalTranslate"></p>
  </div>
  } @else {
  <div class="static-text card_align">
    <p [innerHTML]="'ENDCOVERAGE_NOTELIGIBLE_TEXT_02' | globalTranslate"></p>
  </div>
  }
  } @else {
  <div class="static-text">
    <p>{{ "RMC_ENDCOVERAGE_STATIC_TEXT_01" | globalTranslate }}</p>
    <p [innerHTML]="'RMC_ENDCOVERAGE_STATIC_TEXT_02' | globalTranslate"></p>
  </div>
  <div class="checkbox-container mt-4 mb-3">
    <div class="d-flex align-items-center mb-1">
      <span class="text-danger fw-bold me-2" aria-hidden="true">*</span>
      <nh-checkbox name="calledYes" [index]="''" [control]="terminateCoverageForm?.controls['calledYes']"
        checkedValue="checked" [mandatory]="false" (change)="onCheckboxChange('calledYes')"
        class="endCoverage_check"></nh-checkbox>
      <label for="checkbox-calledYes" style="cursor: pointer"
        [innerHTML]="'ENDCOVERAGE_CHECKBOX_YES_LABEL' | globalTranslate">
      </label>
    </div>
    <div class="d-flex align-items-center mb-3">
      <span class="me-2" style="visibility: hidden" aria-hidden="true">*</span>
      <nh-checkbox name="calledNo" [index]="''" [control]="terminateCoverageForm?.controls['calledNo']"
        checkedValue="checked" [mandatory]="false" (change)="onCheckboxChange('calledNo')"
        class="endCoverage_check"></nh-checkbox>
      <label for="checkbox-calledNo" style="cursor: pointer"
        [innerHTML]="'ENDCOVERAGE_CHECKBOX_NO_LABEL' | globalTranslate">
      </label>
    </div>
  </div>
  @if(showMembers){
  <h1 class="section-header">{{ "End Coverage" | globalTranslate }}</h1>
  <hr />
  <p>{{ "RMC_VOLTERM_STATIC_TEXT_01" | globalTranslate }}</p>
  <p>{{ "END_COVERAGE_STATIC_TEXT3" | globalTranslate }}</p>
  <div class="row ps-3 pe-3">
    @for (indiv of members; track indiv; let i = $index) {
    <div [ngClass]="{ applyColor: selectedTile(indiv) }" class="card card-body shadow me-3 mt-3 col-md-5" tabindex="0">
      <div (click)="selectedAction(indiv)">
        <div class="d-flex align-items-center">
          <ul>
            <li>
              <strong>{{ indiv.firstNam }} {{ indiv.lastNam }} </strong>
              <strong>{{ indiv.age }}</strong>
              <strong>{{ indiv.genderCd }}</strong>
            </li>
            <li>
              <div>
                {{ "Case:" | globalTranslate }}
                <strong>{{ indiv.caseNum }}</strong>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    } @if (hohId?.length) {
    <div id="bckgrnd" class="card card-body shadow mt-3 col-md-5" [ngClass]="{ applyColor: selectedTile(hohId) }"
      (click)="selectedAction(hohId)" tabindex="0">
      <div class="d-flex align-items-center ps-2">
        <div>{{ "END_COVERAGE_STATIC_TEXT4" | globalTranslate }}</div>
      </div>
    </div>
    }
    <br />
  </div>
  <br />
  @if(selectedIndivList.length > 0){
  <nh-field [attr.aria-required]="true" [mandatory]="true" label="{{ 'RMC_VOLTERM_MOVEOUT' | globalTranslate }}"
    class="label-section">
    <select nhTranslate name="moveOutHousehold" [items]="tableCodeValue('YESNO', 'data.moveSomeoneOutSw')"
      [attr.aria-label]="'RMC_VOLTERM_MOVEOUT' | globalTranslate" [formControl]="$any(getControl('data.moveSomeoneOutSw'))"></select>
  </nh-field>
  <nh-alert type="warning" [isOpen]="isY('data.moveSomeoneOutSw')" class="investigate-banner">
    <div class="row">
      <div class="col-auto icon">
        <img src="../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="" />
      </div>
      <div class="col message">
        <span class="visually-hidden">{{ "Alert" | globalTranslate }}</span>
        <span [innerHtml]="'RMC_VOLTERM_MOVEOUT_WARNING' | globalTranslate"></span>
      </div>
    </div>
  </nh-alert>

  }
  } @else if(terminateCoverageForm?.get('calledNo')?.value === 'checked') {
  <div class="mt-4 mb-4 text-center">
    <p [innerHTML]="'RMC_ENDCOVERAGE_NO_TEXT_01' | globalTranslate"></p>
    <p [innerHTML]="'RMC_ENDCOVERAGE_NO_TEXT_02' | globalTranslate"></p>
    <div class="row volterm_btn_container">
      <div class="col-auto hohMember_btn">
        <button id="volTerm_btn" class="btn btn-block btn-outline-secondary" (click)="goToHohScreen()">
          {{ "RMC_VOLTERM_BUTTON_01" | globalTranslate }}
        </button>
      </div>
      <div class="col-auto go_to_screen">
        <button id="volTerm_btn" class="btn btn-block btn-outline-secondary" (click)="goToMainScreen()">
          {{ "RMC_VOLTERM_BUTTON_02" | globalTranslate }}
        </button>
      </div>
    </div>
  </div>
  }
  }
  }
</nh-form>